import config from '../config/environment';
import api from '../config/axios';

export const testProductionCORS = async () => {
  console.log('=== Production CORS Test ===');
  console.log('Environment Info:', config.getEnvironmentInfo());
  
  const testResults = {
    environment: config.getEnvironmentInfo(),
    tests: [],
    summary: ''
  };

  // Test 1: Check if we're in production
  const isProduction = config.isProduction;
  testResults.tests.push({
    name: 'Environment Check',
    status: isProduction ? 'PASS' : 'FAIL',
    message: isProduction ? 'Running in production mode' : 'Not in production mode',
    details: config.getEnvironmentInfo()
  });

  // Test 2: Check API URL configuration
  const apiUrl = config.API_URL;
  const expectedApiUrl = 'https://api.aarogai.com/api';
  const apiUrlCorrect = apiUrl === expectedApiUrl;
  testResults.tests.push({
    name: 'API URL Configuration',
    status: apiUrlCorrect ? 'PASS' : 'FAIL',
    message: apiUrlCorrect ? 'API URL correctly configured' : `API URL should be ${expectedApiUrl}, got ${apiUrl}`,
    details: { expected: expectedApiUrl, actual: apiUrl }
  });

  // Test 3: Test basic connectivity
  try {
    console.log('Testing basic connectivity to:', apiUrl);
    const response = await api.get('/health', { timeout: 5000 });
    testResults.tests.push({
      name: 'Basic Connectivity',
      status: 'PASS',
      message: 'Successfully connected to API',
      details: { status: response.status, statusText: response.statusText }
    });
  } catch (error) {
    testResults.tests.push({
      name: 'Basic Connectivity',
      status: 'FAIL',
      message: 'Failed to connect to API',
      details: {
        error: error.message,
        code: error.code,
        status: error.response?.status,
        isCorsError: error.code === 'ERR_NETWORK' || error.response?.status === 0
      }
    });
  }

  // Test 4: Test CORS preflight (OPTIONS request)
  try {
    console.log('Testing CORS preflight...');
    const preflightResponse = await fetch(apiUrl + '/health', {
      method: 'OPTIONS',
      mode: 'cors',
      headers: {
        'Origin': window.location.origin,
        'Access-Control-Request-Method': 'GET',
        'Access-Control-Request-Headers': 'Content-Type, Authorization'
      }
    });
    
    testResults.tests.push({
      name: 'CORS Preflight',
      status: 'PASS',
      message: 'CORS preflight successful',
      details: {
        status: preflightResponse.status,
        corsHeaders: {
          'Access-Control-Allow-Origin': preflightResponse.headers.get('Access-Control-Allow-Origin'),
          'Access-Control-Allow-Methods': preflightResponse.headers.get('Access-Control-Allow-Methods'),
          'Access-Control-Allow-Headers': preflightResponse.headers.get('Access-Control-Allow-Headers')
        }
      }
    });
  } catch (error) {
    testResults.tests.push({
      name: 'CORS Preflight',
      status: 'FAIL',
      message: 'CORS preflight failed',
      details: {
        error: error.message,
        suggestion: 'Backend needs to handle OPTIONS requests and set proper CORS headers'
      }
    });
  }

  // Generate summary
  const passedTests = testResults.tests.filter(test => test.status === 'PASS').length;
  const totalTests = testResults.tests.length;
  testResults.summary = `${passedTests}/${totalTests} tests passed`;

  console.log('=== CORS Test Results ===');
  testResults.tests.forEach(test => {
    console.log(`${test.status}: ${test.name} - ${test.message}`);
    if (test.details) {
      console.log('  Details:', test.details);
    }
  });
  console.log('Summary:', testResults.summary);

  return testResults;
};

export const getCORSRecommendations = () => {
  const recommendations = {
    backend: [
      'Configure CORS middleware to allow requests from https://admin.aarogai.com',
      'Handle OPTIONS preflight requests for all endpoints',
      'Set Access-Control-Allow-Origin header to https://admin.aarogai.com',
      'Include Access-Control-Allow-Methods: GET, POST, PUT, DELETE, OPTIONS',
      'Include Access-Control-Allow-Headers: Content-Type, Authorization, X-Requested-With'
    ],
    frontend: [
      'Ensure REACT_APP_API_URL=https://api.aarogai.com/api in production',
      'Set NODE_ENV=production',
      'Set REACT_APP_ENV=https://admin.aarogai.com/',
      'Remove proxy dependency (setupProxy.js only works in development)'
    ],
    deployment: [
      'Build the app with: npm run build',
      'Deploy the build folder to your hosting service',
      'Ensure HTTPS is enabled on both frontend and backend'
    ]
  };

  return recommendations;
}; 